/** Finds a site entry from userContext.sites by id or siteId */
export const findUserContextSiteById = (sites, siteId) => {
  if (!sites?.length || siteId == null) {
    return null
  }

  return (
    sites.find(
      site =>
        String(site?.siteId) === String(siteId) ||
        String(site?.id) === String(siteId),
    ) || null
  )
}

/** Filters user context to include only the specific course */
export const filterUserContextForCourse = (
  userContext,
  courseName,
  programKey,
) => {
  if (!userContext?.sites) {
    return userContext
  }

  const clonedUserContext = structuredClone(userContext)

  const filteredUserContext = {
    ...clonedUserContext,
    sites: clonedUserContext.sites
      .filter(site => site?.programs?.[programKey])
      .map(site => {
        const program = site.programs[programKey]
        const targetCourse = program.courses?.find(
          course => course?.name === courseName,
        )

        if (!targetCourse) {
          return null
        }

        return {
          ...site,
          programs: {
            [programKey]: {
              ...program,
              courses: [targetCourse],
            },
          },
        }
      })
      .filter(Boolean),
  }

  return filteredUserContext
}
